module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.lAction === 'view') ? _c('v-tabs', {
    attrs: {
      "flat": "",
      "color": "primary",
      "dark": "",
      "grow": "",
      "height": "40",
      "fixed-tabs": ""
    },
    on: {
      "change": function($event) {
        return _vm.refreshDashboard(true)
      }
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tab', {
    attrs: {
      "href": "#tab-0"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.tabitems[0] + ' (' + _vm.visitorStatAtGate.waiting + ')') + "\n    ")]), _vm._v(" "), _c('v-tab', {
    attrs: {
      "href": "#tab-1"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.tabitems[1] + ' (' + _vm.visitorStatAtGate.inside + ')') + "\n    ")])], 1) : _vm._e(), _vm._v(" "), _c('v-container', {
    staticClass: "pa-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.lAction === 'view') ? _c('v-tabs-items', {
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', {
    attrs: {
      "value": "tab-0"
    }
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.visitHead,
      "items": _vm.waiting,
      "hide-actions": "",
      "disable-initial-sort": "",
      "no-data-text": "Nobody is waiting"
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', {
          staticClass: "pl-2 text-xs-center"
        }, [_c('v-icon', [_vm._v(_vm._s(props.item.icon))])], 1), _vm._v(" "), _c('td', {
          staticClass: "pa-0"
        }, [_vm._v(_vm._s(props.item.visitor_name))]), _vm._v(" "), _c('td', {
          staticClass: "pa-0"
        }, [_vm._v(_vm._s(props.item.visiting))]), _vm._v(" "), _c('td', {
          class: 'pa-0 text-xs-center subheading ' + (props.item.approval_status.includes('Approved') ? 'green' : props.item.approval_status.includes('Rejected') && !props.item.approval_status.includes('Notifying') && !props.item.approval_status.includes('Calling') ? 'red' : (props.item.approval_status.includes('Notifying') || props.item.approval_status.includes('Calling') || props.item.approval_status.includes('Push')) ? 'blue' : 'orange') + ' lighten-2'
        }, [(props.item.approval_status.includes('Approved') && props.item.approval_status.split(',').length > 1) ? _c('span', [_vm._v("Partly Approved")]) : (props.item.approval_status.includes('Notifying') || props.item.approval_status.includes('Calling') || props.item.approval_status.includes('Push')) ? _c('span', [_vm._v("Pending")]) : _c('span', [_vm._v(_vm._s(props.item.approval_status))]), _vm._v(" "), _c('div', [_c('v-btn', {
          attrs: {
            "small": "",
            "outline": ""
          },
          on: {
            "click": function($event) {
              return _vm.viewRecord(props.item, 'status')
            }
          }
        }, [_vm._v("View")]), _vm._v(" "), (props.item.approval_status.includes('Approved')) ? _c('v-btn', {
          attrs: {
            "small": "",
            "outline": ""
          },
          on: {
            "click": function($event) {
              return _vm.sentInside(props.item)
            }
          }
        }, [_vm._v("Sent inside")]) : (!props.item.approval_status.includes('Notifying') && !props.item.approval_status.includes('Calling')) ? _c('v-btn', {
          attrs: {
            "small": "",
            "outline": ""
          },
          on: {
            "click": function($event) {
              return _vm.clearVisitor(props.item)
            }
          }
        }, [_vm._v("Not Allowed")]) : _vm._e()], 1)])])]
      }
    }], null, false, 3081202393)
  }), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('v-tab-item', {
    attrs: {
      "value": "tab-1"
    }
  }, [_c('div', {
    staticClass: "grey lighten-4 pa-3"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pa-0 ml-1",
    attrs: {
      "append-icon": "search",
      "hide-details": "",
      "placeholder": "Search",
      "clearable": ""
    },
    model: {
      value: (_vm.searchDash),
      callback: function($$v) {
        _vm.searchDash = $$v
      },
      expression: "searchDash"
    }
  })], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.insideHeadSm : _vm.insideHead,
      "items": _vm.inside,
      "hide-actions": "",
      "disable-initial-sort": "",
      "no-data-text": "Nobody is inside",
      "search": _vm.searchDash
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.viewRecord(props.item)
            }
          }
        }, [_c('td', {
          staticClass: "pl-2 text-xs-center"
        }, [_c('v-icon', [_vm._v(_vm._s(props.item.icon))])], 1), _vm._v(" "), _c('td', {
          staticClass: "pa-0"
        }, [_vm._v(_vm._s(props.item.visitor_name))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "pa-0"
        }, [_vm._v(_vm._s(props.item.visiting))]) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "pa-0"
        }, [_vm._v(_vm._s(_vm.handy.formatDateTime(props.item.in_time)))]), _vm._v(" "), _c('td', {
          staticClass: "pl-3 pr-1 text-xs-left subheading"
        }, [_c('v-icon', {
          staticClass: "pr-1"
        }, [_vm._v(_vm._s(props.item.vehicle_type === 'Two Wheeler' ? 'directions_bike' : 'directions_car'))]), _c('b', [_vm._v(_vm._s(props.item.vehicle_no ? props.item.vehicle_no.toUpperCase() : '-'))])], 1)])]
      }
    }], null, false, 1993911004)
  }), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center",
    staticStyle: {
      "position": "fixed",
      "bottom": "15px",
      "width": "100%"
    }
  }, [_c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.viewRegister.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      View Register\n    ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prepareEntry()
      }
    }
  }, [_vm._v("\n    New Visitor Entry\n  ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'create') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": ""
    }
  }, [_c('v-stepper', {
    staticClass: "elevation-0",
    model: {
      value: (_vm.entryStep),
      callback: function($$v) {
        _vm.entryStep = $$v
      },
      expression: "entryStep"
    }
  }, [_c('v-stepper-items', [_c('v-stepper-content', {
    staticClass: "pa-0",
    attrs: {
      "step": "1"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm7": "",
      "md5": "",
      "mx-auto": ""
    }
  }, [_c('div', {
    staticClass: "ma-2"
  }, [_c('v-card', {
    staticClass: "mx-1 my-1"
  }, [_c('v-card-title', {
    staticClass: "title primary--text pb-1"
  }, [_vm._v("\n                    NORMAL VISITORS\n                  ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "py-0"
  }, [_c('v-list', {
    staticClass: "pa-0"
  }, [_vm._l((_vm.normalList), function(normal, idx) {
    return [_c('v-list-tile', {
      key: normal.visitor_cat,
      attrs: {
        "avatar": ""
      },
      on: {
        "click": function($event) {
          return _vm.entryNext('normal', normal)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      attrs: {
        "large": ""
      }
    }, [_vm._v(_vm._s(normal.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(normal.visitor_cat)
      }
    }), _vm._v(" "), (normal.visitor_cat === 'Vendor') ? _c('span', {
      staticClass: "caption"
    }, [_vm._v("facility or household service provider")]) : _vm._e(), _vm._v(" "), (normal.visitor_cat === 'Daily Helper') ? _c('span', {
      staticClass: "caption"
    }, [_vm._v("maid, drivers, etc with no easypass")]) : _vm._e()], 1)], 1), _vm._v(" "), (idx < _vm.normalList.length - 1) ? _c('v-divider') : _vm._e()]
  })], 2)], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mx-1 my-2"
  }, [_c('v-card-title', {
    staticClass: "title primary--text"
  }, [_vm._v("\n                  PRE-APPROVED VISITORS\n                ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-0"
  }, [_c('v-list', {
    staticClass: "pa-0 white--text"
  }, [_vm._l((_vm.spclList), function(spcl, idx) {
    return [_c('v-list-tile', {
      key: spcl.visitor_cat,
      class: (idx === 0 ? 'green' : idx === 1 ? 'blue' : 'warning'),
      attrs: {
        "avatar": ""
      },
      on: {
        "click": function($event) {
          return _vm.entryNext(spcl.visitor_type, spcl)
        }
      }
    }, [_c('v-list-tile-avatar', [(spcl.visitor_cat.includes('Staff')) ? _c('v-icon', {
      staticClass: "white--text",
      attrs: {
        "large": ""
      }
    }, [_vm._v(_vm._s(spcl.icon))]) : _c('v-icon', {
      staticClass: "white--text"
    }, [_vm._v(_vm._s(spcl.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(spcl.visitor_cat)
      }
    })], 1)], 1)]
  })], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center mt-2"
  }, [_c('v-btn', {
    on: {
      "click": _vm.goHome
    }
  }, [_c('v-icon', [_vm._v("home")])], 1)], 1)], 1)])], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticClass: "pa-0",
    attrs: {
      "step": "2"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subheading primary lighten-2 white--text py-1"
  }, [_c('v-icon', {
    staticClass: "px-2 white--text",
    attrs: {
      "x-large": ""
    }
  }, [_vm._v(_vm._s(_vm.lVisitor.icon))]), _vm._v("\n          " + _vm._s(_vm.lVisitor.visitor_cat && _vm.lVisitor.visitor_cat.toUpperCase()) + "\n        ")], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-3"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm7": "",
      "md5": "",
      "mx-auto": ""
    }
  }, [_c('v-form', {
    ref: "form2"
  }, [(_vm.lVisitor.visitor_type === 'normal') ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    staticClass: "text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.config.COMM_COUNTRY_CODE === 'MY' && _vm.config.COMM_ID === 337) ? _c('v-btn', {
    class: 'ma-0 mr-1 py-4 ' + (_vm.normalVisitMode === 'DL' ? 'warning black--text' : ''),
    on: {
      "click": function($event) {
        return _vm.setNormalVisitMode('DL')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("badge")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    class: 'ma-0 py-4 ' + (_vm.normalVisitMode === 'MN' ? 'warning black--text' : ''),
    on: {
      "click": function($event) {
        return _vm.setNormalVisitMode('MN')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("contact_phone")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-3 title",
    attrs: {
      "xs12": ""
    }
  }, [(this.normalVisitMode === 'DL') ? _c('span', [_vm._v("Take Photo Of Driving License")]) : (this.normalVisitMode === 'MN') ? _c('span', [_vm._v("Enter Mobile Number")]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pb-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('vue-tel-input-vuetify', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.normalVisitMode === 'MN'),
      expression: "this.normalVisitMode === 'MN'"
    }],
    ref: "refMob",
    staticClass: "title",
    attrs: {
      "placeholder": "Enter mobile number",
      "label": "",
      "rules": [_vm.rules.required],
      "input-options": {
        showDialCode: true
      },
      "defaultCountry": _vm.config.COMM_COUNTRY_CODE
    },
    on: {
      "input": _vm.keepCursor,
      "validate": _vm.validateMob
    },
    nativeOn: {
      "keydown": function($event) {
        return _vm.ignoreBackspace.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.lVisitor.visitor_phone),
      callback: function($$v) {
        _vm.$set(_vm.lVisitor, "visitor_phone", $$v)
      },
      expression: "lVisitor.visitor_phone"
    }
  })], 1), _vm._v(" "), (this.normalVisitMode === 'DL' && _vm.lVisitor.visitor_id) ? _c('v-flex', {
    staticClass: "pb-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "title",
    attrs: {
      "label": "ID",
      "maxlength": "25",
      "rules": [_vm.rules.required],
      "hide-details": ""
    },
    model: {
      value: (_vm.lVisitor.visitor_id),
      callback: function($$v) {
        _vm.$set(_vm.lVisitor, "visitor_id", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "lVisitor.visitor_id"
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.normalVisitMode === 'DL' && !_vm.lVisitor.visitor_img_url) ? _c('v-flex', {
    staticClass: "text-xs-center pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pb-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "auto",
      "position": "absolute",
      "top": "0",
      "left": "0",
      "bottom": "0",
      "right": "0",
      "height": "185px",
      "width": "285px",
      "z-index": "1",
      "border": "3px solid yellow",
      "border-radius": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "top": "32px",
      "left": "95px",
      "height": "50px",
      "width": "180px",
      "z-index": "1",
      "border": "2px solid orange"
    }
  })]), _vm._v(" "), _c('video', {
    attrs: {
      "id": "cam",
      "width": "300px",
      "height": "auto",
      "autoplay": ""
    }
  })])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "pt-1"
  }, [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.captureAndRecognizeOCR
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("camera")])], 1)], 1)])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lVisitor.visitor_phone || _vm.lVisitor.visitor_id) ? _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.lVisitor.found_in_db && (_vm.lVisitor.is_valid_number || _vm.lVisitor.visitor_id)) ? _c('v-chip', {
    staticClass: "black--text success lighten-3",
    attrs: {
      "disabled": ""
    }
  }, [_c('v-avatar', {
    staticClass: "success"
  }, [_c('v-icon', {
    staticClass: "white--text"
  }, [_vm._v("check")])], 1), _vm._v("\n                      Known visitor\n                    ")], 1) : _vm._e(), _vm._v(" "), (_vm.lVisitor.alreadyWaiting) ? _c('v-chip', {
    staticClass: "error white--text",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("\n                      But, already waiting\n                    ")]) : (_vm.lVisitor.alreadyInside) ? _c('v-chip', {
    staticClass: "error white--text",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("\n                      But, already inside\n                    ")]) : (!_vm.lVisitor.found_in_db && (_vm.lVisitor.is_valid_number || _vm.lVisitor.visitor_id)) ? _c('v-chip', {
    staticClass: "black--text error lighten-3",
    attrs: {
      "disabled": ""
    }
  }, [_c('v-avatar', {
    staticClass: "error white--text"
  }, [_c('v-icon', {
    staticClass: "white--text"
  }, [_vm._v("clear")])], 1), _vm._v(" "), _c('span', [_vm._v("No visitor history for given number")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.lVisitor.is_valid_number || _vm.lVisitor.visitor_id) ? _c('v-flex', {
    staticClass: "pb-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "px-4"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "d-flex": "",
      "xs4": ""
    }
  }, [(_vm.lVisitor.visitor_img_url) ? _c('div', {
    directives: [{
      name: "viewer",
      rawName: "v-viewer",
      value: (_vm.options),
      expression: "options"
    }]
  }, [
    [_c('v-avatar', {
      staticClass: "grey lighten-4",
      attrs: {
        "size": "100"
      }
    }, [_c('img', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": _vm.lVisitor.visitor_img_url.includes('base64') ? _vm.lVisitor.visitor_img_url : _vm.config.STATIC_FILES_DIR + _vm.lVisitor.visitor_img_url,
        "data-source": _vm.lVisitor.visitor_img_url.includes('base64') ? _vm.lVisitor.visitor_img_url : _vm.config.STATIC_FILES_DIR + _vm.lVisitor.visitor_img_url
      }
    })]), _vm._v(" "), _c('v-btn', {
      staticClass: "ma-1",
      attrs: {
        "small": "",
        "icon": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      },
      on: {
        "click": _vm.captureInDialog
      }
    }, [_vm._v("photo_camera")])], 1)]
  ], 2) : _c('v-avatar', {
    staticClass: "grey lighten-4",
    attrs: {
      "size": 100
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "50px"
    },
    on: {
      "click": _vm.captureInDialog
    }
  }, [_vm._v("photo_camera")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-3",
    attrs: {
      "d-flex": "",
      "xs8": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "py-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "title",
    attrs: {
      "label": "Name",
      "maxlength": "25",
      "rules": [_vm.rules.required],
      "hide-details": ""
    },
    model: {
      value: (_vm.lVisitor.visitor_name),
      callback: function($$v) {
        _vm.$set(_vm.lVisitor, "visitor_name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "lVisitor.visitor_name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "title",
    attrs: {
      "label": "No. of persons",
      "rules": [_vm.rules.required],
      "type": "number",
      "hide-details": ""
    },
    model: {
      value: (_vm.lVisitor.no_of_persons),
      callback: function($$v) {
        _vm.$set(_vm.lVisitor, "no_of_persons", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "lVisitor.no_of_persons"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-0",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Vehicle Type",
      "items": _vm.vehicleTypes,
      "rules": [_vm.rules.required],
      "hide-details": ""
    },
    on: {
      "input": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.lVisitor.vehicle_type),
      callback: function($$v) {
        _vm.$set(_vm.lVisitor, "vehicle_type", $$v)
      },
      expression: "lVisitor.vehicle_type"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-3 mt-0",
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Vehicle No.",
      "maxlength": "15",
      "rules": _vm.lVisitor.vehicle_type !== 'None' ? [_vm.rules.required] : [],
      "hide-details": ""
    },
    model: {
      value: (_vm.lVisitor.vehicle_no),
      callback: function($$v) {
        _vm.$set(_vm.lVisitor, "vehicle_no", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "lVisitor.vehicle_no"
    }
  })], 1), _vm._v(" "), (_vm.lVisitor.visitor_cat === 'Delivery' || _vm.lVisitor.visitor_cat === 'Cab' || _vm.lVisitor.visitor_cat === 'Vendor') ? _c('v-flex', {
    staticClass: "text-xs-center mt-1",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.lVisitor.org_img_url) ? _c('v-avatar', {
    attrs: {
      "size": "50",
      "tile": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgOrg = true
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.config.STATIC_FILES_DIR + _vm.lVisitor.org_img_url
    }
  })]) : _c('v-chip', {
    staticClass: "warning",
    on: {
      "click": function($event) {
        _vm.dlgOrg = true
      }
    }
  }, [_vm._v(_vm._s(_vm.lVisitor.visitor_org || 'Choose ' + _vm.lVisitor.visitor_cat + ' Organization'))])], 1) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e()], 1) : _c('v-layout', {
    staticClass: "text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.lVisitor.visitor_type === 'invite') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    class: 'ma-0 mr-1 py-4 ' + (_vm.inviteMode === 'QR' ? 'warning black--text' : ''),
    on: {
      "click": function($event) {
        return _vm.setInviteMode('QR')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("qr_code_2")])], 1), _vm._v(" "), _c('v-btn', {
    class: 'ma-0 py-4 ' + (_vm.inviteMode === 'OTP' ? 'warning black--text' : ''),
    on: {
      "click": function($event) {
        return _vm.setInviteMode('OTP')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("pin")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-3 title",
    attrs: {
      "xs12": ""
    }
  }, [(this.inviteMode === 'QR') ? _c('span', [_vm._v("Scan QR Code")]) : (this.inviteMode === 'OTP') ? _c('span', [_vm._v("Enter Invitation OTP")]) : _vm._e()]), _vm._v(" "), (this.inviteMode === 'QR') ? _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-text', {
    staticStyle: {
      "width": "100%",
      "height": "340px"
    }
  }, [_c('qrcode-stream', {
    on: {
      "decode": _vm.onQRCodeDecode
    }
  })], 1)], 1) : _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    ref: "refInviteOtp",
    attrs: {
      "type": "number",
      "label": "Invitation OTP",
      "rules": [_vm.rules.required]
    },
    on: {
      "input": function($event) {
        return _vm.loadInvite(_vm.lVisitor.invite_otp)
      }
    },
    model: {
      value: (_vm.lVisitor.invite_otp),
      callback: function($$v) {
        _vm.$set(_vm.lVisitor, "invite_otp", $$v)
      },
      expression: "lVisitor.invite_otp"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Vehicle Type",
      "items": _vm.vehicleTypes,
      "hide-details": "",
      "rules": [_vm.rules.required]
    },
    on: {
      "input": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.lVisitor.vehicle_type),
      callback: function($$v) {
        _vm.$set(_vm.lVisitor, "vehicle_type", $$v)
      },
      expression: "lVisitor.vehicle_type"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Vehicle Number",
      "maxlength": "15",
      "hide-details": "",
      "rules": _vm.lVisitor.vehicle_type !== 'None' ? [_vm.rules.required] : []
    },
    model: {
      value: (_vm.lVisitor.vehicle_no),
      callback: function($$v) {
        _vm.$set(_vm.lVisitor, "vehicle_no", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "lVisitor.vehicle_no"
    }
  })], 1)], 1)], 1) : (_vm.lVisitor.visitor_type === 'easypass') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    class: 'ma-0 mr-1 py-4 ' + (_vm.easyPassMode === 'FR' ? 'warning black--text' : ''),
    staticStyle: {
      "min-width": "50px"
    },
    on: {
      "click": function($event) {
        return _vm.setEasyPassMode('FR')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("portrait")])], 1), _vm._v(" "), _c('v-btn', {
    class: 'ma-0 mr-1 py-4 ' + (_vm.easyPassMode === 'QR' ? 'warning black--text' : ''),
    staticStyle: {
      "min-width": "50px"
    },
    on: {
      "click": function($event) {
        return _vm.setEasyPassMode('QR')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("qr_code_2")])], 1), _vm._v(" "), _c('v-btn', {
    class: 'ma-0 mr-1 py-4 ' + (_vm.easyPassMode === 'EN' ? 'warning black--text' : ''),
    staticStyle: {
      "min-width": "50px"
    },
    on: {
      "click": function($event) {
        return _vm.setEasyPassMode('EN')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("pin")])], 1), _vm._v(" "), _c('v-btn', {
    class: 'ma-0 py-4 ' + (_vm.easyPassMode === 'MN' ? 'warning black--text' : ''),
    staticStyle: {
      "min-width": "50px"
    },
    on: {
      "click": function($event) {
        return _vm.setEasyPassMode('MN')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("contact_phone")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-3 title",
    attrs: {
      "xs12": ""
    }
  }, [(this.easyPassMode === 'FR') ? _c('span', [_vm._v("Take Photo Of Visitor")]) : (this.easyPassMode === 'QR') ? _c('span', [_vm._v("Scan QR Code")]) : (this.easyPassMode === 'EN') ? _c('span', [_vm._v("Enter EasyPass Number")]) : (this.easyPassMode === 'MN') ? _c('span', [_vm._v("Enter Mobile Number")]) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.easyPassMode === 'EN'),
      expression: "this.easyPassMode === 'EN'"
    }],
    ref: "refEZNo",
    attrs: {
      "type": "number",
      "placeholder": "EasyPass number",
      "rules": _vm.lVisitor.is_face_recog ? [] : [_vm.rules.required]
    },
    on: {
      "input": function($event) {
        return _vm.loadEasyPass(_vm.lVisitor.easypass_no, '', 'EN')
      }
    },
    model: {
      value: (_vm.lVisitor.easypass_no),
      callback: function($$v) {
        _vm.$set(_vm.lVisitor, "easypass_no", $$v)
      },
      expression: "lVisitor.easypass_no"
    }
  }), _vm._v(" "), _c('vue-tel-input-vuetify', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.easyPassMode === 'MN'),
      expression: "this.easyPassMode === 'MN'"
    }],
    ref: "refMob",
    attrs: {
      "label": "",
      "placeholder": "Enter mobile number",
      "rules": [_vm.rules.required],
      "input-options": {
        showDialCode: true
      },
      "defaultCountry": _vm.config.COMM_COUNTRY_CODE
    },
    on: {
      "input": _vm.keepCursor,
      "validate": _vm.validateEzMob
    },
    nativeOn: {
      "keydown": function($event) {
        return _vm.ignoreBackspace.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.lVisitor.visitor_phone),
      callback: function($$v) {
        _vm.$set(_vm.lVisitor, "visitor_phone", $$v)
      },
      expression: "lVisitor.visitor_phone"
    }
  })], 1), _vm._v(" "), (this.easyPassMode === 'FR' || (_vm.lVisitor.visitor_img_url && !_vm.lVisitor.visitor_img_url.includes('base64'))) ? _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-text', [(!_vm.lVisitor.visitor_img_url) ? _c('div', [_c('video', {
    attrs: {
      "id": "cam",
      "width": "195px",
      "height": "auto",
      "autoplay": ""
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "pt-1"
  }, [_c('v-btn', {
    staticClass: "mb-0",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.captureAndRecognize
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("camera")])], 1)], 1)]) : _c('div', {
    staticClass: "white--text subheading"
  }, [_c('v-avatar', {
    attrs: {
      "tile": "",
      "size": "255px"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.lVisitor.visitor_img_url.includes('base64') ? _vm.lVisitor.visitor_img_url : _vm.config.STATIC_FILES_DIR + _vm.lVisitor.visitor_img_url
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mx-4"
  }, [(_vm.lVisitor.is_face_recog) ? _c('div', {
    staticClass: "success px-2 py-1"
  }, [_c('strong', [_vm._v(_vm._s(_vm.lVisitor.visitor_name))]), _vm._v(" "), _c('div', {
    staticClass: "pb-1"
  }, [_vm._v(_vm._s(_vm.lVisitor.visitor_cat))])]) : (_vm.lVisitor.face_recog_err) ? _c('div', {
    staticClass: "error px-2 py-3"
  }, [_vm._v("\n                                    " + _vm._s(_vm.lVisitor.face_recog_err) + "\n                                  ")]) : _c('div', {
    staticClass: "info px-2 py-3"
  }, [_vm._v("\n                                    " + _vm._s(_vm.faceProgText) + "\n                                  ")])])], 1)])], 1)], 1)], 1) : (this.easyPassMode === 'QR') ? _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-text', {
    staticStyle: {
      "width": "100%",
      "height": "335px"
    }
  }, [_c('qrcode-stream', {
    on: {
      "decode": _vm.onQRCodeDecode
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Vehicle Type",
      "items": _vm.vehicleTypes,
      "hide-details": "",
      "rules": [_vm.rules.required]
    },
    on: {
      "input": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.lVisitor.vehicle_type),
      callback: function($$v) {
        _vm.$set(_vm.lVisitor, "vehicle_type", $$v)
      },
      expression: "lVisitor.vehicle_type"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Vehicle Number",
      "maxlength": "15",
      "hide-details": "",
      "rules": _vm.lVisitor.vehicle_type !== 'None' ? [_vm.rules.required] : []
    },
    model: {
      value: (_vm.lVisitor.vehicle_no),
      callback: function($$v) {
        _vm.$set(_vm.lVisitor, "vehicle_no", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "lVisitor.vehicle_no"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lVisitor.visitor_type === 'staff') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-text', [(!_vm.lVisitor.visitor_img_url) ? _c('div', [_c('video', {
    attrs: {
      "id": "cam",
      "width": "80%",
      "height": "auto",
      "autoplay": ""
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "pt-1"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.captureAndRecognize
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("camera")])], 1)], 1)]) : _c('div', {
    staticClass: "white--text"
  }, [_c('v-avatar', {
    attrs: {
      "tile": "",
      "size": "89%"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.lVisitor.visitor_img_url.includes('base64') ? _vm.lVisitor.visitor_img_url : _vm.config.STATIC_FILES_DIR + _vm.lVisitor.visitor_img_url
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mx-4"
  }, [(_vm.lVisitor.is_face_recog) ? _c('div', {
    staticClass: "success px-2 py-1"
  }, [_c('strong', [_vm._v(_vm._s(_vm.lVisitor.visitor_name))]), _vm._v(" "), _c('div', {
    staticClass: "pb-1"
  }, [_vm._v(_vm._s(_vm.lVisitor.visitor_cat))]), _vm._v(" "), (_vm.lVisitor.log_action) ? _c('div', {
    staticClass: "display-1 py-2"
  }, [_vm._v(_vm._s(_vm.lVisitor.log_action))]) : _vm._e()]) : (_vm.lVisitor.face_recog_err) ? _c('div', {
    staticClass: "error px-2 py-3"
  }, [_vm._v("\n                                " + _vm._s(_vm.lVisitor.face_recog_err) + "\n                              ")]) : _c('div', {
    staticClass: "info px-2 py-3"
  }, [_vm._v("\n                                " + _vm._s(_vm.faceProgText) + "\n                              ")])])], 1)])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.lVisitor.visitor_type === 'invite' && _vm.lVisitor.is_valid_number && _vm.lVisitor.is_invite_recog) ? _c('v-chip', {
    staticClass: "black--text success lighten-3 mt-3",
    attrs: {
      "disabled": ""
    }
  }, [_c('v-avatar', {
    staticClass: "success"
  }, [_c('v-icon', {
    staticClass: "white--text"
  }, [_vm._v("check")])], 1), _vm._v("\n                      Valid OTP\n                    ")], 1) : _vm._e(), _vm._v(" "), (_vm.lVisitor.alreadyWaiting) ? _c('v-chip', {
    staticClass: "error white--text mt-3",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("\n                      Already waiting\n                    ")]) : (_vm.lVisitor.alreadyInside) ? _c('v-chip', {
    staticClass: "error white--text mt-3",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("\n                      Already inside\n                    ")]) : ((_vm.lVisitor.easypass_err || _vm.lVisitor.invite_err) && _vm.lVisitor.is_valid_number) ? _c('v-chip', {
    staticClass: "black--text error lighten-3 mt-3",
    attrs: {
      "disabled": ""
    }
  }, [_c('v-avatar', {
    staticClass: "error white--text"
  }, [_c('v-icon', {
    staticClass: "white--text"
  }, [_vm._v("clear")])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lVisitor.easypass_err || _vm.lVisitor.invite_err))])], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center mt-2"
  }, [_c('v-btn', {
    staticClass: "mr-1 ml-1",
    on: {
      "click": _vm.entryBack
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-1 ml-1",
    on: {
      "click": _vm.goHome
    }
  }, [_c('v-icon', [_vm._v("home")])], 1), _vm._v(" "), (_vm.lVisitor.visitor_type !== 'staff') ? _c('v-btn', {
    staticClass: "ml-1 accent",
    attrs: {
      "disabled": (!_vm.lVisitor.is_valid_number && !_vm.lVisitor.visitor_id) || _vm.lVisitor.alreadyWaiting || _vm.lVisitor.alreadyInside || (_vm.lVisitor.visitor_type === 'easypass' && (_vm.lVisitor.easypass_err !== '' || (!_vm.lVisitor.is_face_recog && !_vm.lVisitor.is_easypass_recog))) || (_vm.lVisitor.visitor_type === 'invite' && !_vm.lVisitor.is_invite_recog)
    },
    on: {
      "click": function($event) {
        return _vm.entryNext()
      }
    }
  }, [_vm._v("Next")]) : _c('v-btn', {
    staticClass: "ml-1 accent",
    attrs: {
      "disabled": !_vm.lVisitor.is_face_recog
    },
    on: {
      "click": function($event) {
        return _vm.entryNext()
      }
    }
  }, [_vm._v("Next Staff")])], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticClass: "pa-0",
    attrs: {
      "step": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subheading primary lighten-1 white--text py-1"
  }, [_c('v-icon', {
    staticClass: "px-2 white--text",
    attrs: {
      "x-large": ""
    }
  }, [_vm._v(_vm._s(_vm.lVisitor.icon))]), _vm._v("\n          " + _vm._s(_vm.lVisitor.visitor_cat && _vm.lVisitor.visitor_cat.toUpperCase()) + "\n        ")], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm7": "",
      "md5": "",
      "mx-auto": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-3"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "title primary--text py-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('span', {
    staticClass: "mb-1"
  }, [_vm._v("VISITING AREA")]), _vm._v(" "), _c('span', [_c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgSearchUnit = true;
        _vm.search = ''
      }
    }
  }, [_c('v-icon', [_vm._v("search")])], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.choosenBlock) ? _c('v-chip', {
    staticClass: "yellow my-0",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.choosenBlock + ' ' + _vm.choosenUnit))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center subheading pt-0 grey--text",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', [_c('i', [_vm._v(_vm._s(_vm.choosenBlock ? 'Choose the house' : _vm.config.COMM_COUNTRY_CODE === 'MY' ? 'Choose the jalan' : 'Choose the block'))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "height": "280px"
    }
  }, [_c('v-flex', {
    staticStyle: {
      "overflow": "auto"
    },
    attrs: {
      "xs12": ""
    }
  }, [(!_vm.choosenBlock) ? _c('div', [(_vm.blocks.length <= 10) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.blocks), function(block, b) {
    return _c('v-flex', {
      key: b,
      attrs: {
        "xs6": ""
      }
    }, [_c('v-btn', {
      staticClass: "py-2 title ma-0",
      staticStyle: {
        "width": "100%"
      },
      on: {
        "click": function($event) {
          return _vm.chooseBlock('R', block)
        }
      }
    }, [_vm._v(_vm._s(block.block_nm))])], 1)
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-btn', {
    staticClass: "py-2 title ma-0",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": function($event) {
        return _vm.chooseBlock('C')
      }
    }
  }, [_vm._v("COMMON AREA")])], 1)], 2) : _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.blocks), function(block, b) {
    return _c('v-flex', {
      key: b,
      attrs: {
        "xs3": ""
      }
    }, [_c('v-btn', {
      staticClass: "py-2 title ma-0",
      staticStyle: {
        "width": "100%"
      },
      on: {
        "click": function($event) {
          return _vm.chooseBlock('R', block)
        }
      }
    }, [_vm._v(_vm._s(block.block_nm))])], 1)
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-btn', {
    staticClass: "py-2 title ma-0",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": function($event) {
        return _vm.chooseBlock('C')
      }
    }
  }, [_vm._v("COMMON AREA")])], 1)], 2)], 1) : _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.units), function(unit, u) {
    return _c('v-flex', {
      key: u,
      attrs: {
        "xs3": ""
      }
    }, [_c('v-btn', {
      staticClass: "py-2 title ma-0",
      on: {
        "click": function($event) {
          return _vm.chooseUnit(unit)
        }
      }
    }, [_vm._v(_vm._s(unit.unit_no))])], 1)
  }), 1)], 1)])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "title primary--text mt-2 mb-1",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', [_vm._v(_vm._s('CHOOSEN HOUSES (' + _vm.lVisitor.unit.filter(function (rec) { return rec.selected !== false; }).length + ')'))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center"
  }, [_c('v-layout', {
    staticStyle: {
      "height": "110px"
    }
  }, [_c('v-flex', {
    staticStyle: {
      "overflow": "auto"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.lVisitor.unit.filter(function (rec) { return rec.selected !== false; })), function(unit, u) {
    return _c('div', {
      key: u
    }, [_c('v-chip', {
      staticClass: "info white--text title ma-1",
      attrs: {
        "close": ""
      },
      model: {
        value: (unit.selected),
        callback: function($$v) {
          _vm.$set(unit, "selected", $$v)
        },
        expression: "unit.selected"
      }
    }, [_vm._v(_vm._s(unit.block_and_unit))])], 1)
  }), 0)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center mt-2"
  }, [_c('v-btn', {
    staticClass: "mr-1 ml-1",
    on: {
      "click": _vm.entryBack
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-1 ml-1",
    on: {
      "click": _vm.goHome
    }
  }, [_c('v-icon', [_vm._v("home")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-1 ml-1 accent",
    on: {
      "click": function($event) {
        return _vm.entryNext()
      }
    }
  }, [_vm._v("Next")])], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticClass: "pa-0",
    attrs: {
      "step": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subheading primary lighten-1 white--text py-1"
  }, [_c('v-icon', {
    staticClass: "px-2 white--text",
    attrs: {
      "x-large": ""
    }
  }, [_vm._v(_vm._s(_vm.lVisitor.icon))]), _vm._v("\n          " + _vm._s(_vm.lVisitor.visitor_cat && _vm.lVisitor.visitor_cat.toUpperCase()) + "\n        ")], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm7": "",
      "md5": "",
      "mx-auto": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-3 title"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs4": ""
    }
  }, [(_vm.lVisitor.visitor_img_url) ? _c('div', {
    directives: [{
      name: "viewer",
      rawName: "v-viewer",
      value: (_vm.options),
      expression: "options"
    }],
    staticClass: "clearfix"
  }, [
    [_c('v-avatar', {
      staticClass: "grey lighten-4",
      attrs: {
        "size": "100"
      }
    }, [_c('img', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": _vm.lVisitor.visitor_img_url.includes('base64') ? _vm.lVisitor.visitor_img_url : _vm.config.STATIC_FILES_DIR + _vm.lVisitor.visitor_img_url,
        "data-source": _vm.lVisitor.visitor_img_url.includes('base64') ? _vm.lVisitor.visitor_img_url : _vm.config.STATIC_FILES_DIR + _vm.lVisitor.visitor_img_url
      }
    })])]
  ], 2) : _c('v-avatar', {
    staticClass: "grey lighten-4",
    attrs: {
      "size": "100"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey",
      "size": "90px"
    }
  }, [_vm._v("person")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs8": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "display-1",
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lVisitor.visitor_name) + "\n                      "), (_vm.lVisitor.no_of_persons > 1) ? _c('v-chip', {
    staticClass: "black--text subheading mt-0",
    attrs: {
      "outline": "",
      "disabled": ""
    }
  }, [_vm._v("+ " + _vm._s(_vm.lVisitor.no_of_persons - 1))]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v(_vm._s(_vm.lVisitor.vehicle_type === 'Two Wheeler' ? 'directions_bike' : 'directions_car'))]), _vm._v("\n                      " + _vm._s(_vm.lVisitor.vehicle_no && _vm.lVisitor.vehicle_no.toUpperCase() || 'NA') + "\n                    ")], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-3 primary--text text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n                  VISITING\n                ")]), _vm._v(" "), (_vm.lVisitor.unit.length) ? _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, _vm._l((_vm.lVisitor.unit), function(unit, i) {
    return _c('v-card', {
      key: i,
      staticClass: "mb-2",
      attrs: {
        "flat": ""
      }
    }, [_c('div', {
      staticClass: "pa-2"
    }, [_c('v-divider')], 1), _vm._v(" "), _c('v-chip', {
      staticClass: "display-1 black--text white",
      attrs: {
        "close": _vm.lVisitor.unit.length > 1
      },
      on: {
        "input": _vm.refreshChosenUnits
      },
      model: {
        value: (unit.selected),
        callback: function($$v) {
          _vm.$set(unit, "selected", $$v)
        },
        expression: "unit.selected"
      }
    }, [_vm._v("\n                      " + _vm._s(unit.block_and_unit) + "\n                    ")]), _vm._v(" "), _vm._l((unit.cust_name_list.split(',')), function(cust, c) {
      return _c('div', {
        key: c,
        staticClass: "caption"
      }, [(cust.includes('No contact available')) ? _c('span', {
        staticClass: "red--text"
      }, [_c('i', [_vm._v(_vm._s(cust))])]) : _c('span', [_c('i', [_vm._v(_vm._s(cust))])])])
    }), _vm._v(" "), (_vm.lVisitor.nobody_at_units.findIndex(function (rec) { return rec.unit_id === unit.unit_id; }) >= 0) ? _c('div', {
      staticClass: "subheading"
    }, [_vm._v("\n                      Manual Security Approval\n                      "), _c('v-btn', {
      staticClass: "ma-0",
      class: unit.is_man_appr ? 'success white--text' : 'grey lighten-1 white--text',
      attrs: {
        "small": "",
        "fab": "",
        "depressed": ""
      },
      on: {
        "click": function($event) {
          return _vm.toggleManAppr(unit)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "medium": ""
      }
    }, [_vm._v("check")])], 1)], 1) : _vm._e()], 2)
  }), 1) : _c('v-flex', {
    staticClass: "display-1 black--text text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', [_vm._v("Common Area")]), _vm._v(" "), _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v(_vm._s(_vm.lVisitor.common.com_area_app_pair && _vm.lVisitor.common.com_area_app_pair.cust_name))])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center mt-2"
  }, [_c('v-btn', {
    staticClass: "mr-1 ml-1",
    on: {
      "click": _vm.entryBack
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-1",
    on: {
      "click": _vm.goHome
    }
  }, [_c('v-icon', [_vm._v("home")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-1 accent",
    attrs: {
      "disabled": _vm.beingSaved || (_vm.lVisitor.nobody_at_units.length !== _vm.lVisitor.unit.filter(function (rec) { return rec.is_man_appr; }).length)
    },
    on: {
      "click": function($event) {
        return _vm.submitEntry()
      }
    }
  }, [_vm._v(_vm._s(_vm.lVisitor.visitor_type === 'normal' ? 'Submit for approval' : 'Send Inside'))])], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'view-reg') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-sm": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-1"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tabs', {
    model: {
      value: (_vm.regTab),
      callback: function($$v) {
        _vm.regTab = $$v
      },
      expression: "regTab"
    }
  }, _vm._l((_vm.regTabItems), function(regitem, n) {
    return _c('v-tab', {
      key: n,
      attrs: {
        "href": ("#tab-" + n)
      },
      on: {
        "click": function($event) {
          return _vm.loadReg(regitem)
        }
      }
    }, [_vm._v("\n              " + _vm._s(regitem) + "\n            ")])
  }), 1)], 1), _vm._v(" "), (_vm.regTab === 'tab-3') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    staticClass: "ml-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgPeriodFrom",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.periodFrom
    },
    on: {
      "update:returnValue": function($event) {
        _vm.periodFrom = $event
      },
      "update:return-value": function($event) {
        _vm.periodFrom = $event
      }
    },
    model: {
      value: (_vm.dlgPeriodFrom),
      callback: function($$v) {
        _vm.dlgPeriodFrom = $$v
      },
      expression: "dlgPeriodFrom"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "From",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.periodFrom),
      callback: function($$v) {
        _vm.periodFrom = $$v
      },
      expression: "periodFrom"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.periodFrom),
      callback: function($$v) {
        _vm.periodFrom = $$v
      },
      expression: "periodFrom"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgPeriodFrom = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgPeriodFrom.save(_vm.periodFrom)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgPeriodTo",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.periodTo
    },
    on: {
      "update:returnValue": function($event) {
        _vm.periodTo = $event
      },
      "update:return-value": function($event) {
        _vm.periodTo = $event
      }
    },
    model: {
      value: (_vm.dlgPeriodTo),
      callback: function($$v) {
        _vm.dlgPeriodTo = $$v
      },
      expression: "dlgPeriodTo"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "To",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.periodTo),
      callback: function($$v) {
        _vm.periodTo = $$v
      },
      expression: "periodTo"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.periodTo),
      callback: function($$v) {
        _vm.periodTo = $$v
      },
      expression: "periodTo"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgPeriodTo = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgPeriodTo.save(_vm.periodTo)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    staticClass: "accent",
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.loadReg()
      }
    }
  }, [_vm._v("\n      Go\n    ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "title info--text mt-3 text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n  " + _vm._s(_vm.register.length) + " records found\n")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "grey lighten-4 pa-3"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "mx-auto": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pa-0 ml-1",
    attrs: {
      "append-icon": "search",
      "hide-details": "",
      "placeholder": "Search",
      "clearable": ""
    },
    model: {
      value: (_vm.searchDash),
      callback: function($$v) {
        _vm.searchDash = $$v
      },
      expression: "searchDash"
    }
  })], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.regHead,
      "items": _vm.register,
      "hide-actions": "",
      "disable-initial-sort": "",
      "no-data-text": "Register is empty for chosen period",
      "search": _vm.searchDash
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: props.item.visitor_status === 'Waiting' ? 'grey--text' : '',
          on: {
            "click": function($event) {
              return _vm.viewRecord(props.item)
            }
          }
        }, [_c('td', {
          staticClass: "pa-0 text-xs-center"
        }, [_c('v-icon', {
          class: props.item.visitor_status === 'Waiting' ? 'grey--text' : ''
        }, [_vm._v(_vm._s(props.item.icon))])], 1), _vm._v(" "), _c('td', {
          staticClass: "pa-0"
        }, [_vm._v(_vm._s(props.item.visitor_name))]), _vm._v(" "), _c('td', {
          staticClass: "pa-0"
        }, [_vm._v(_vm._s(props.item.visiting))]), _vm._v(" "), _c('td', {
          staticClass: "pa-0 text-xs-center"
        }, [_vm._v(_vm._s(props.item.in_time ? _vm.handy.getTime12Hrs(props.item.in_time) : props.item.visitor_status))]), _vm._v(" "), _c('td', {
          staticClass: "pa-0 text-xs-center"
        }, [_vm._v(_vm._s(props.item.out_time ? _vm.handy.getTime12Hrs(props.item.out_time) : '-'))])])]
      }
    }], null, false, 1182628093)
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center",
    staticStyle: {
      "position": "fixed",
      "bottom": "15px",
      "width": "100%"
    }
  }, [_c('v-btn', {
    on: {
      "click": _vm.goHome
    }
  }, [_c('v-icon', [_vm._v("home")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "310px",
      "persistent": ""
    },
    model: {
      value: (_vm.secPostDlg),
      callback: function($$v) {
        _vm.secPostDlg = $$v
      },
      expression: "secPostDlg"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n      Choose security post!\n    ")]), _vm._v(" "), _c('v-card-text', [_c('v-data-table', {
    attrs: {
      "items": _vm.secPostList,
      "disable-initial-sort": "",
      "hide-actions": "",
      "hide-headers": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.chooseSecPost(props.item)
            }
          }
        }, [_c('td', {
          staticClass: "text-xs-center"
        }, [_c('span', {
          staticClass: "title primary--text"
        }, [_vm._v(_vm._s(props.item.security_post))])])])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": _vm.$vuetify.breakpoint.smAndUp ? '300px' : '280px',
      "persistent": ""
    },
    model: {
      value: (_vm.dlgPreCond),
      callback: function($$v) {
        _vm.dlgPreCond = $$v
      },
      expression: "dlgPreCond"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_vm._v("\n      COVID-19 Check\n    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "subheading pt-2"
  }, [_c('v-container', {
    staticClass: "px-1 py-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pl-0 pt-3",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("masks")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-4",
    attrs: {
      "xs6": ""
    }
  }, [_c('span', [_c('b', [_vm._v("Wearing mask")])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0",
    class: _vm.lVisitor.is_visitor_mask_on ? 'success white--text' : 'grey lighten-1 white--text',
    attrs: {
      "fab": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.lVisitor.is_visitor_mask_on = !_vm.lVisitor.is_visitor_mask_on
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "large": ""
    }
  }, [_vm._v("check")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-2",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-icon', {
    staticClass: "mt-1",
    attrs: {
      "large": ""
    }
  }, [_vm._v("fa fa-thermometer-3")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-4",
    attrs: {
      "xs6": ""
    }
  }, [_c('b', [_vm._v("Temperature °" + _vm._s(_vm.config.COMM_COUNTRY_CODE === 'MY' ? 'C' : 'F'))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    class: 'pa-0 title ' + (_vm.lVisitor.visitor_temp >= _vm.bodyTempStart && _vm.lVisitor.visitor_temp <= _vm.bodyTempEnd ? _vm.lVisitor.visitor_temp > _vm.bodyTempNormal ? 'red lighten-2 white--text' : 'success white--text' : ''),
    attrs: {
      "hide-details": "",
      "hide-details": "",
      "type": "number",
      "box": ""
    },
    model: {
      value: (_vm.lVisitor.visitor_temp),
      callback: function($$v) {
        _vm.$set(_vm.lVisitor, "visitor_temp", $$v)
      },
      expression: "lVisitor.visitor_temp"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgPreCond = false, _vm.lVisitor.is_visitor_mask_on = false, _vm.lVisitor.visitor_temp = ''
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "accent",
    attrs: {
      "depressed": "",
      "disabled": !_vm.lVisitor.is_visitor_mask_on || Number(_vm.lVisitor.visitor_temp) < _vm.bodyTempStart || Number(_vm.lVisitor.visitor_temp) > _vm.bodyTempEnd
    },
    on: {
      "click": function($event) {
        _vm.lVisitor.is_visitor_pre_cond_met = true, _vm.entryNext()
      }
    }
  }, [_vm._v("Continue")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "persistent": ""
    },
    model: {
      value: (_vm.dlgCommApr),
      callback: function($$v) {
        _vm.dlgCommApr = $$v
      },
      expression: "dlgCommApr"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title pb-0"
  }, [_vm._v("\n      Choose approver\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgCommApr = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-data-table', {
    attrs: {
      "items": _vm.approvers,
      "disable-initial-sort": "",
      "hide-actions": "",
      "hide-headers": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.chooseCommApr(props.item)
            }
          }
        }, [_c('td', {
          staticClass: "text-xs-center"
        }, [_c('span', [_vm._v(_vm._s(props.item.cust_name))])])])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "persistent": ""
    },
    model: {
      value: (_vm.dlgOrg),
      callback: function($$v) {
        _vm.dlgOrg = $$v
      },
      expression: "dlgOrg"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title pb-0 pt-2"
  }, [_vm._v("\n      " + _vm._s('Choose ' + _vm.lVisitor.visitor_cat + ' Org.') + "\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgOrg = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-3 py-2"
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": "",
      "grid-list-sm": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "placeholder": "Search",
      "solo": "",
      "hide-details": "",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.filterOrgList()
      }
    },
    model: {
      value: (_vm.searchOrg),
      callback: function($$v) {
        _vm.searchOrg = $$v
      },
      expression: "searchOrg"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-btn', {
    on: {
      "click": _vm.prepareNewOrg
    }
  }, [_vm._v("Add new")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "subheading primary--text"
  }, [_vm._v("Top Visits")])]), _vm._v(" "), _vm._l((_vm.topVisitorOrgList), function(org, t) {
    return _c('v-flex', {
      key: t,
      attrs: {
        "xs3": "",
        "sm2": ""
      }
    }, [_c('v-card', {
      staticClass: "warning",
      attrs: {
        "flat": "",
        "height": "65px"
      },
      on: {
        "click": function($event) {
          return _vm.chooseVisitOrg(org)
        }
      }
    }, [(org.org_img_url) ? _c('img', {
      staticClass: "image",
      attrs: {
        "src": _vm.config.STATIC_FILES_DIR + org.org_img_url,
        "width": "100%",
        "height": "100%"
      }
    }) : _c('div', {
      staticClass: "subheading py-2 text-xs-center"
    }, [_vm._v(_vm._s(org.visitor_org))])])], 1)
  }), _vm._v(" "), _c('v-alert', {
    attrs: {
      "value": !_vm.topVisitorOrgList.length,
      "color": "info"
    }
  }, [_vm._v("\n            No data available\n          ")]), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-1",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "subheading primary--text"
  }, [_vm._v(_vm._s(_vm.searchOrg ? 'Search Result' : 'All'))])]), _vm._v(" "), _vm._l((_vm.filteredOrgList), function(org, o) {
    return _c('v-flex', {
      key: _vm.topVisitorOrgList.length + o,
      attrs: {
        "xs3": "",
        "sm2": ""
      }
    }, [_c('v-card', {
      staticClass: "warning",
      attrs: {
        "flat": "",
        "height": "65px"
      },
      on: {
        "click": function($event) {
          return _vm.chooseVisitOrg(org)
        }
      }
    }, [(org.org_img_url) ? _c('img', {
      staticClass: "image",
      attrs: {
        "src": _vm.config.STATIC_FILES_DIR + org.org_img_url,
        "width": "100%",
        "height": "100%"
      }
    }) : _c('div', {
      staticClass: "subheading py-2 text-xs-center"
    }, [_vm._v(_vm._s(org.visitor_org))])])], 1)
  }), _vm._v(" "), _c('v-alert', {
    attrs: {
      "value": !_vm.filteredOrgList.length,
      "color": "info"
    }
  }, [_vm._v("\n            No data available\n          ")])], 2)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "310px",
      "persistent": ""
    },
    model: {
      value: (_vm.dlgNewOrg),
      callback: function($$v) {
        _vm.dlgNewOrg = $$v
      },
      expression: "dlgNewOrg"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n      Add Organization\n      "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Organization name",
      "maxlength": "50",
      "rules": [_vm.rules.required],
      "hide-details": ""
    },
    model: {
      value: (_vm.tmpVisitorOrg),
      callback: function($$v) {
        _vm.tmpVisitorOrg = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "tmpVisitorOrg"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.dlgNewOrg = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.addNewVisitorOrg
    }
  }, [_vm._v("Save")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "310px",
      "persistent": ""
    },
    model: {
      value: (_vm.dlgSearchUnit),
      callback: function($$v) {
        _vm.dlgSearchUnit = $$v
      },
      expression: "dlgSearchUnit"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title pb-0 pt-2"
  }, [_vm._v("\n      Search a house\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dlgSearchUnit = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "placeholder": "Search",
      "solo": "",
      "hide-details": "",
      "clearable": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3",
    staticStyle: {
      "height": "500px"
    }
  }, [_c('v-flex', {
    staticStyle: {
      "overflow": "auto"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.unitsHead,
      "items": _vm.masterUnits,
      "hide-actions": "",
      "hide-headers": "",
      "search": _vm.search,
      "disable-initial-sort": "",
      "height": "100px"
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.chooseUnit(props.item)
            }
          }
        }, [_c('td', {
          staticClass: "subheading"
        }, [_c('div', [_vm._v("\n                  " + _vm._s(props.item.block_and_unit) + "\n                ")]), _vm._v(" "), _vm._l((props.item.cust_name_list && props.item.cust_name_list.split(',')), function(cust, c) {
          return _c('div', {
            staticClass: "caption info--text"
          }, [_vm._v("\n                  " + _vm._s(cust) + "\n                ")])
        })], 2)])]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "310px"
    },
    model: {
      value: (_vm.vdoDlg),
      callback: function($$v) {
        _vm.vdoDlg = $$v
      },
      expression: "vdoDlg"
    }
  }, [_c('v-card', [_c('v-card-text', [(_vm.vdoDlg) ? _c('video', {
    staticStyle: {
      "width": "280px",
      "height": "210px"
    },
    attrs: {
      "id": "cam",
      "autoplay": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center pb-3 pt-0"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.capturePhoto(), _vm.vdoDlg = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("camera")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "15px",
      "right": "10px"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "color": "grey",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.stopCamera(), _vm.vdoDlg = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "310px"
    },
    model: {
      value: (_vm.viewDetDlg),
      callback: function($$v) {
        _vm.viewDetDlg = $$v
      },
      expression: "viewDetDlg"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title grey lighten-4 px-2 py-1"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "medium": ""
    }
  }, [_vm._v(_vm._s(_vm.lVisitor.icon))]), _vm._v("\n      " + _vm._s(_vm.lVisitor.visitor_cat) + "\n      "), _c('v-chip', {
    class: (_vm.lVisitor.visitor_status === 'Waiting' ? 'info' : _vm.lVisitor.visitor_status === 'Inside' ? 'success' : _vm.lVisitor.visitor_status === 'Overstay' ? 'orange' : 'grey') + ' white--text',
    attrs: {
      "small": "",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.lVisitor.visitor_status))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.viewDetDlg = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-xs-center subheading px-2 py-0"
  }, [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.lVisitor.visitor_name))]), _c('br'), _vm._v(" "), (_vm.lVisitor.visitor_type !== 'normal' && _vm.lVisitor.visitor_phone) ? _c('span', [_vm._v(_vm._s('*******' + _vm.lVisitor.visitor_phone.substring(_vm.lVisitor.visitor_phone.length - 3)))]) : _c('span', [_c('a', {
    attrs: {
      "href": 'tel:' + _vm.lVisitor.visitor_phone
    }
  }, [_vm._v(_vm._s(_vm.lVisitor.visitor_phone))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.lVisitor.visitor_img_url) ? _c('div', {
    directives: [{
      name: "viewer",
      rawName: "v-viewer",
      value: (_vm.options),
      expression: "options"
    }],
    staticClass: "clearfix"
  }, [
    [_c('v-avatar', {
      staticClass: "grey lighten-4",
      attrs: {
        "size": "100"
      }
    }, [_c('img', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": _vm.lVisitor.visitor_img_url.includes('base64') ? _vm.lVisitor.visitor_img_url : (_vm.config.STATIC_FILES_DIR + _vm.lVisitor.visitor_img_url),
        "data-source": _vm.lVisitor.visitor_img_url.includes('base64') ? _vm.lVisitor.visitor_img_url : (_vm.config.STATIC_FILES_DIR + _vm.lVisitor.visitor_img_url)
      }
    })])]
  ], 2) : _c('v-avatar', {
    staticClass: "grey lighten-4",
    attrs: {
      "size": "100"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey",
      "size": "90px"
    }
  }, [_vm._v("person")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n            Visiting\n          ")]), _vm._v(" "), (_vm.lVisitor.visiting) ? _c('v-flex', {
    staticClass: "title mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_vm._l((_vm.lVisitor.visiting.split(',')), function(flat) {
    return _c('div', [_vm._v("\n              " + _vm._s(flat) + "\n            ")])
  }), _vm._v(" "), (_vm.lVisitor.visiting_area === 'C') ? _c('div', {
    staticClass: "caption"
  }, [_vm._v("\n              " + _vm._s(_vm.lVisitor.comm_area_app) + "\n            ")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('b', [_vm._v("IN:")]), _vm._v(" " + _vm._s(_vm.lVisitor.in_time ? _vm.handy.getTime12Hrs(_vm.lVisitor.in_time) : '-') + "\n          ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('b', [_vm._v("OUT:")]), _vm._v(" " + _vm._s(_vm.lVisitor.out_time ? _vm.handy.getTime12Hrs(_vm.lVisitor.out_time) : "-") + "\n          ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary warning--text title pa-2",
    attrs: {
      "disabled": ""
    }
  }, [_c('v-icon', {
    staticClass: "warning--text mr-2",
    attrs: {
      "large": ""
    }
  }, [_vm._v(_vm._s(_vm.lVisitor.vehicle_type === 'Two Wheeler' ? 'directions_bike' : 'directions_car'))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.lVisitor.vehicle_no && _vm.lVisitor.vehicle_no.toUpperCase() || 'NA'))])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-2",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.lVisitor.visitor_status === 'Inside') ? _c('v-btn', {
    staticClass: "accent",
    on: {
      "click": function($event) {
        return _vm.checkOut()
      }
    }
  }, [_vm._v("Check-out")]) : (_vm.lVisitor.visitor_status === 'Left' && _vm.lVisitor.in_time) ? _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.undoCheckOut()
      }
    }
  }, [_vm._v("Undo Check-out")]) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "400px",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.viewStatusDlg),
      callback: function($$v) {
        _vm.viewStatusDlg = $$v
      },
      expression: "viewStatusDlg"
    }
  }, [(_vm.viewStatusDlg) ? _c('v-card', [_c('v-card-title', {
    staticClass: "title grey lighten-4 px-2 py-1"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "medium": ""
    }
  }, [_vm._v(_vm._s(_vm.lVisitor.icon))]), _vm._v("\n      " + _vm._s(_vm.lVisitor.visitor_cat + ' [' + _vm.lVisitor.visitor_name + ']') + "\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeStatusDlg.apply(null, arguments)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-xs-center px-0 py-0"
  }, [_c('v-container', {
    attrs: {
      "grid-list-sm": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "subheading",
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n            Approval status\n          ")]), _vm._v(" "), _c('v-flex', {
    staticClass: "title",
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lVisitor.approval_status.includes('Approved') && _vm.lVisitor.approval_status.split(',').length > 1 ? 'Partly Approved' : (_vm.lVisitor.approval_status.includes('Notifying') || _vm.lVisitor.approval_status.includes('Calling') || _vm.lVisitor.approval_status.includes('Push')) ? 'Pending' : _vm.lVisitor.approval_status) + "\n          ")]), _vm._v(" "), (_vm.lVisitor.approval_status === 'Rejected') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lVisitor.denied_due_to) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-expansion-panel', {
    attrs: {
      "popout": ""
    },
    model: {
      value: (_vm.lVisitor.last_chosen_panel),
      callback: function($$v) {
        _vm.$set(_vm.lVisitor, "last_chosen_panel", $$v)
      },
      expression: "lVisitor.last_chosen_panel"
    }
  }, _vm._l((_vm.lVisitor.detail), function(det, i) {
    return _c('v-expansion-panel-content', {
      key: i,
      scopedSlots: _vm._u([{
        key: "header",
        fn: function() {
          return [_c('v-layout', {
            staticClass: "py-2",
            attrs: {
              "row": "",
              "wrap": ""
            }
          }, [_c('v-flex', {
            staticClass: "title pt-2",
            attrs: {
              "xs6": ""
            }
          }, [(_vm.lVisitor.whats_next[det.unit_id].is_ignored) ? _c('span', [_c('strike', [_vm._v(_vm._s(det.block_and_unit))])], 1) : _c('span', [_vm._v("\n                    " + _vm._s(det.block_and_unit) + "\n                  ")])]), _vm._v(" "), _c('v-flex', {
            staticClass: "text-xs-right",
            attrs: {
              "xs6": ""
            }
          }, [_c('v-chip', {
            class: 'ml-0 mr-2 mt-1 mb-1 black--text caption ' + ((det.approval_status_list.includes('Approved') ? 'green' : det.approval_status_list.includes('Rejected') && !det.approval_status_list.includes('Notifying') && !det.approval_status_list.includes('Calling') ? 'red' : (det.approval_status_list.includes('Notifying') || det.approval_status_list.includes('Calling') || det.approval_status_list.includes('Push')) ? 'blue' : 'orange') + ' lighten-2'),
            attrs: {
              "small": "",
              "disabled": ""
            }
          }, [_vm._v("\n                  " + _vm._s(det.approval_status_list.includes('Approved') && det.approval_status_list.split(',').length > 1 ? 'Partly Approved' : (det.approval_status_list.includes('Notifying') || det.approval_status_list.includes('Calling') || det.approval_status_list.includes('Push')) ? 'Pending' : det.approval_status_list) + "\n                ")])], 1)], 1)]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _c('v-card', [_c('v-card-text', {
      staticClass: "py-1"
    }, _vm._l((det.approvers), function(apr, a) {
      return _c('v-layout', {
        key: a,
        staticClass: "py-1",
        attrs: {
          "row": "",
          "wrap": ""
        }
      }, [_c('v-flex', {
        staticClass: "pt-2",
        attrs: {
          "xs6": ""
        }
      }, [_vm._v("\n                  " + _vm._s(apr.cust_name) + "\n                ")]), _vm._v(" "), _c('v-flex', {
        staticClass: "pt-2 text-xs-right",
        attrs: {
          "xs4": ""
        }
      }, [_c('span', {
        class: (apr.approval_status === 'Notifying' || apr.approval_status === 'Calling' ? 'blue' : apr.approval_status === 'Approved' ? 'green' : apr.approval_status === 'Rejected' ? 'red' : 'orange') + '--text'
      }, [_vm._v(_vm._s(apr.approval_status))])]), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs2": ""
        }
      }, [(apr.approval_status === 'No Response' || apr.approval_status === 'Not Reachable' || apr.approval_status === 'Rejected') ? _c('v-btn', {
        staticClass: "ma-0 grey lighten-4",
        attrs: {
          "small": "",
          "fab": "",
          "depressed": ""
        }
      }, [_c('a', {
        staticStyle: {
          "text-decoration": "none"
        },
        attrs: {
          "href": 'tel:' + apr.contact_phone
        }
      }, [_c('v-icon', {
        attrs: {
          "medium": ""
        }
      }, [_vm._v("phone")])], 1)]) : _vm._e()], 1)], 1)
    }), 1)], 1), _vm._v(" "), (!(det.approval_status_list.includes('Notifying') || det.approval_status_list.includes('Calling') || det.approval_status_list.includes('Push') || det.approval_status_list === 'Approved')) ? _c('v-card', [_c('v-card-text', {
      staticClass: "pa-3"
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('strong', [_vm._v("What's next?")])]), _vm._v(" "), _c('v-flex', {
      staticClass: "pt-3",
      attrs: {
        "xs10": ""
      }
    }, [_vm._v("\n                  Verified with " + _vm._s(_vm.lVisitor.visiting_area === 'R' ? 'resident' : 'approver') + " "), (_vm.lVisitor.whats_next[det.unit_id].approval_mode) ? _c('span', {
      staticClass: "caption info--text"
    }, [_vm._v(_vm._s(' [' + _vm.lVisitor.whats_next[det.unit_id].approval_mode + ']'))]) : _vm._e()]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('v-btn', {
      staticClass: "ma-0",
      class: _vm.lVisitor.whats_next[det.unit_id].is_man_verif ? 'success white--text' : 'grey lighten-1 white--text',
      attrs: {
        "small": "",
        "fab": "",
        "depressed": ""
      },
      on: {
        "click": function($event) {
          return _vm.toggleManVerif(_vm.lVisitor.whats_next[det.unit_id], 'is_man_verif')
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "medium": ""
      }
    }, [_vm._v("check")])], 1)], 1), _vm._v(" "), (_vm.lVisitor.visiting_area === 'R') ? _c('v-flex', {
      staticClass: "pt-3",
      attrs: {
        "xs10": ""
      }
    }, [_vm._v("\n                  Ignore this house for the current visit\n                ")]) : _vm._e(), _vm._v(" "), (_vm.lVisitor.visiting_area === 'R') ? _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('v-btn', {
      staticClass: "ma-0",
      class: _vm.lVisitor.whats_next[det.unit_id].is_ignored ? 'success white--text' : 'grey lighten-1 white--text',
      attrs: {
        "small": "",
        "fab": "",
        "depressed": ""
      },
      on: {
        "click": function($event) {
          return _vm.toggleManVerif(_vm.lVisitor.whats_next[det.unit_id], 'is_ignored')
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "medium": ""
      }
    }, [_vm._v("check")])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-dialog', {
      attrs: {
        "max-width": "310px",
        "persistent": ""
      },
      model: {
        value: (_vm.dlgManVerif),
        callback: function($$v) {
          _vm.dlgManVerif = $$v
        },
        expression: "dlgManVerif"
      }
    }, [_c('v-card', [_c('v-card-title', {
      staticClass: "title pb-0"
    }, [_vm._v("\n                  Verification mode\n                  "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.toggleManVerif(_vm.lVisitor.whats_next[det.unit_id], 'is_man_verif')
        }
      }
    }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-data-table', {
      attrs: {
        "items": _vm.manAppModes,
        "disable-initial-sort": "",
        "hide-actions": "",
        "hide-headers": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('tr', {
            on: {
              "click": function($event) {
                _vm.lVisitor.whats_next[det.unit_id].approval_mode = props.item;
                _vm.dlgManVerif = false
              }
            }
          }, [_c('td', {
            staticClass: "text-xs-center"
          }, [_c('span', [_vm._v(_vm._s(props.item))])])])]
        }
      }], null, true)
    })], 1)], 1)], 1)], 1) : _vm._e()], 1)
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.lVisitor.approval_status.includes('No Response') || _vm.lVisitor.approval_status.includes('Not Reachable')) ? _c('v-card-actions', {
    staticClass: "pa-3 grey lighten-4"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.retryVisitor
    }
  }, [_vm._v("Retry Notification")]), _vm._v(" "), _c('v-btn', {
    staticClass: "accent",
    attrs: {
      "disabled": _vm.lVisitor.whats_next && Object.values(_vm.lVisitor.whats_next).findIndex(function (rec) { return rec.is_man_verif; }) < 0 && Object.values(_vm.lVisitor.whats_next).findIndex(function (rec) { return rec.is_ignored; }) < 0
    },
    on: {
      "click": function($event) {
        return _vm.submitWhatsNext()
      }
    }
  }, [_vm._v("Submit Changes")])], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 4000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])]), _vm._v(" "), (_vm.load) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "50%",
      "left": "45%"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a9db8f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Visitors.vue
// module id = 907
// module chunks = 5